import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';

import { State } from '../store/reducer';

import * as ArticlesActions from '../store/actions';
import { Filter, BaseType } from '../models/filter.model';
import { environment } from 'src/environments/environment';
import { MediaMatcher } from '@angular/cdk/layout';

export interface BreadcrumbFilter extends BaseType {
  Type: number;
}

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {
  removable = true;

  filters: BreadcrumbFilter[] = [];
  groupfilters: BreadcrumbFilter[] = [];
  queryfilters: string[] = [];

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  constructor(
    private store: Store<State>,
    private router: Router,
    private route: ActivatedRoute,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher
  ) {
    this.mobileQuery = media.matchMedia(environment.mediaMatcher);
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

    this.store.select('filters').subscribe((state: any) => {
      if (state.changeFilters) {
        this.addApplicationsFilters();
        this.addGroupsFilters();
        this.addQueryFilters();

        this.store.dispatch({
          type: ArticlesActions.ActionTypes.FILTERS_CHANGED,
          payload: { filters: Filter }
        });
      }
    });
  }

  ngOnInit() { }

  addApplicationsFilters(): void {
    this.filters = [];

    const make = Filter.Make;
    if (make && make.Name && make.Id) {
      this.pushFilterItem(this.filters, 'Make', 1);
    }

    const model = Filter.Model;
    if (model && model.Name && model.Id) {
      this.pushFilterItem(this.filters, 'Model', 2);
    }

    const type = Filter.Type;
    if (type && type.Name && type.Id) {
      this.pushFilterItem(this.filters, 'Type', 3);
    }
  }

  addGroupsFilters(): void {
    this.groupfilters = [];
    for (let i = 1; i <= 6; i++) {
      const key = `Group${i}`;
      const grp = (Filter as any)[key];
      if (grp && grp.Name && grp.Id) {
        this.pushFilterItem(this.groupfilters, key, i);
      }
    }
  }

  addQueryFilters(): void {
    this.queryfilters = [];
    if (Filter.Query.length) {
      for (let i = 0; i < Filter.Query.length; ++i) {
        decodeURIComponent(Filter.Query[i]);
      }
      this.queryfilters.push(...Filter.Query);
    }
  }

  clearFilters(): void {
    Filter.resetFilters(false);
    this.navigate(true);
  }

  private pushFilterItem(table: BreadcrumbFilter[], type: string, level: number) {
    const it: BreadcrumbFilter = {
      Id: (Filter as any)[type].Id,
      Name: (Filter as any)[type].Name,
      Type: level
    };
    table.push(it);
  }

  remove(filter: BreadcrumbFilter): void {
    this.filters = this.filters.filter(f => f.Type < filter.Type);
    this.navigate(false);
  }

  removeGroup(filter: BreadcrumbFilter): void {
    this.groupfilters = this.groupfilters.filter(f => f.Type < filter.Type);
    this.navigate(false);
  }

  removeWord(filter: string): void {
    this.queryfilters = this.queryfilters.filter(f => f !== filter);
    this.navigate(false);
  }

  private navigate(clear: boolean): void {
    if (!clear) {
      const lastApp = this.filters.length ? this.filters[this.filters.length - 1] : null;
      const lastGroup = this.groupfilters.length ? this.groupfilters[this.groupfilters.length - 1] : null;

      const appLevel = lastApp ? lastApp.Type + 1 : 1;
      const appId = lastApp ? lastApp.Id : 0;
      const groupLevel = lastGroup ? lastGroup.Type + 1 : 1;
      const groupId = lastGroup ? lastGroup.Id : 0;

      if (this.queryfilters.length) {
        this.router.navigate([
          Filter.Language,
          this.queryfilters.join(' '),
          appLevel,
          appId,
          groupLevel,
          groupId
        ]);
      } else {
        this.router.navigate([
          Filter.Language,
          appLevel,
          appId,
          groupLevel,
          groupId
        ]);
      }
    } else {
      this.router.navigate(['/' + Filter.Language + '/1/0/1/0']);
    }
  }
}
